<template>
  <span>
    <template v-if="trip.discount_method == 'fix_amount'">
      <currency-context>
        <template v-slot="{ convert }">
          -<span v-text="convert(trip.discount)"></span>&nbsp;off
        </template>
      </currency-context>
    </template>
    <template v-else>
      {{ trip.discount_tag }}
    </template>
  </span>
</template>

<script>
import CurrencyContext from "../core/CurrencyContext";

export default {
  props: ["trip"],
  components: {
    CurrencyContext,
  },
};
</script>
